import {isNotNilOrEmpty} from 'shared/web';

import {RequestVehicle, ResolvedVehicle} from '../../../types/api/api';

export function requestVehicleToResolvedVehicle(
  request: RequestVehicle | null | undefined
): ResolvedVehicle {
  if (!request) {
    return {};
  }
  return {
    make: request.make ?? undefined,
    model: request.modelFamily ?? undefined,
    year: request.firstRegistrationOnYear ?? undefined,
    power: request.power ?? undefined,
    transmission: request.transmission ?? undefined,
    fuel: request.fuelType ?? undefined,
    drive: request.drive ?? undefined,
    bodyType: request.bodyStyle ?? undefined,
    mileage: request.mileage ?? undefined,
    vatDeductible: request.isVatDeductible ?? undefined,
    vin: request.vin ?? undefined,
    equipment: request.features?.filter((f): f is string => isNotNilOrEmpty(f)) ?? undefined,
  };
}
